import { LitElement, css, html, unsafeCSS, nothing } from 'lit';
import styles from './alert.scss?inline';
import { EVENT_CLOSE } from '@/components/alerts/constants.js';

export default class SotbitAlert extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        hideIcon: { type: Boolean, attribute: 'hide-icon' },
        closable: { type: Boolean },
    };

    constructor() {
        super();

        this.hideIcon = false;
        this.showCloseIcon = false;

        this._handleCloseIconClick = this._handleCloseIconClick.bind(this);
    }

    close() {
        queueMicrotask(() => {
            this.dispatchEvent(
                new Event(EVENT_CLOSE, {
                    bubbles: true,
                    cancelable: false,
                    composed: true,
                })
            );
        });

        this.remove();
    }

    _handleCloseIconClick() {
        this.close();
    }

    render() {
        return html`
            <div part="alert">
                ${this.hideIcon
                    ? nothing
                    : html`<sotbit-icon part="icon" icon="error" size="sl" no-padding></sotbit-icon>`}
                <div part="content">
                    <slot name="title"></slot>
                    <slot name="text"></slot>
                </div>
                ${this.closable
                    ? html`
                          <sotbit-icon
                              part="close-icon"
                              icon="close"
                              variant="secondary"
                              size="s"
                              @click="${this._handleCloseIconClick}"
                              no-padding
                              pointer
                          ></sotbit-icon>
                      `
                    : nothing}
            </div>
        `;
    }
}
